export class Message {
  constructor(
    public expression: string,
    public params?: Array<any>
  ) {}
}
